import type { ConstructedDeliverable } from "@/types/types";

export default function getComputedDeliverableIdentifiers(deliverablesData: ConstructedDeliverable[]) {
    return deliverablesData.map(deliverable => {
        let editableGroupValueIds: string[] = [];
        const groupValues = Object.values(deliverable.combination ?? {});

        if (Array.isArray(groupValues)) {
            editableGroupValueIds = groupValues.map(groupValue => {
                if ("groupValueId" in groupValue) {
                    return groupValue.groupValueId;
                }

                return Object.values(groupValue).pop().groupValueId;
            });
        }

        return {
            editableGroupValueIds,
            language: deliverable.language,
            masterTemplateId: deliverable.masterTemplate._id
        };
    });
}
